import axios from 'axios';
import { SECRETS_ENV } from '../Config/firebase';

// Determine API base URL based on environment
const API_BASE_URL = SECRETS_ENV.API_END_POINT



// Verify Turnstile token with backend
export const verifyCaptchaToken = async (token: string) => {
    try {
        console.log('🔐 Verifying Turnstile token with backend..., API_BASE_URL:', API_BASE_URL);
        
        const response = await axios.post(`${API_BASE_URL}/api/otp/captchaverify`, { 
            token: token 
        });

        if (response.data.success) {
            console.log('✅ Turnstile token verified successfully by backend');
            return { success: true, data: response.data };
        } else {
            console.error('❌ Backend verification failed:', response.data);
            return { 
                success: false, 
                message: 'Security verification failed. Please try again.' 
            };
        }
    } catch (error: any) {
        console.error('❌ Error verifying captcha token:', error);
        const errorMessage = error?.response?.data?.message || 'Security verification failed. Please try again.';
        return { success: false, message: errorMessage };
    }
};

// Send OTP via API
export const sendOtpApi = async (phoneNumber: string, turnstileToken: string, type: "whatsapp" | "sms" = "whatsapp") => {
    try {
        console.log('📤 Sending OTP to:', phoneNumber, 'via', type);
        
        const response = await axios.post(`${API_BASE_URL}/api/otp/get`, { 
            phoneNumber: phoneNumber, 
            platform: "web", 
            website: "app.hosaksham.com",
            turnstileToken: turnstileToken ,
            type: type
        });

        return { success: true, data: response.data };
    } catch (error: any) {
        console.error('❌ Error sending OTP:', error);
        const errorMessage = error?.response?.data?.message || error?.message || 'Unable to send OTP. Please try again.';
        return { success: false, message: errorMessage };
    }
};

// Verify OTP via API
export const verifyOtpApi = async (phoneNumber: string, otp: string) => {
    try {
        console.log('🔍 Verifying OTP for:', phoneNumber);
        
        const response = await axios.post(`${API_BASE_URL}/api/otp/verify`, { 
            phoneNumber, 
            otp: otp 
        });

        if (response.data.success && response.data.customToken) {
            console.log('✅ OTP verified successfully');
            return { 
                success: true, 
                customToken: response.data.customToken,
                data: response.data 
            };
        } else {
            return { 
                success: false, 
                message: 'Invalid OTP. Please try again.' 
            };
        }
    } catch (error: any) {
        console.error('❌ Error verifying OTP:', error);
        const errorMessage = error?.response?.data?.message || error?.message || 'Invalid OTP. Please try again.';
        return { success: false, message: errorMessage };
    }
};

